import {
    GET_ACTIVITY_LIST,
    DELETE_ACTIVITY,
    DELETE_ALL_ACTIVITIES,
} from './types';

import { BACKEND_API } from "../../config/middleware";
import API from "../../config/api-url";


export const getActivityList = () => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: GET_ACTIVITY_LIST,
            method: 'get',
            url: API.ACTIVITY
        },
    )
});

export const deleteActivity = id => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: DELETE_ACTIVITY,
            method: 'delete',
            url: `${API.ACTIVITY}${id}`,
        },
    )
});

export const deleteAllActivities = () => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: DELETE_ALL_ACTIVITIES,
            method: 'delete',
            url: API.ACTIVITY,
        },
    )
});